import React from 'react';
import { Tab } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import 'animate.css';

const ProjectTabsLatest = ({ latest }) => {
  return (
    <Tab.Container id="projects-tabs" activeKey="first">
      <Tab.Content>
        <Tab.Pane eventKey="first">
          <div id="proj-first">
            <div className='project-posts'>
              {latest.map((project, index) => (
                <ProjectCard
                  key={index}
                  {...project}
                  delay={index * 0.05}
                />
              ))}
            </div>
          </div>
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

export default ProjectTabsLatest;
